module.exports = __webpack_public_path__ + "media/speech-bubbles/medium-speech-bubble--foot-left--desktop-e36e0df8.svg";